var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleBar',{ref:"scroller",staticClass:"virtual-list"},[_c('div',{staticClass:"list-view-phantom",style:({ height: _vm.contentHeight })},[_c('div',{ref:"content",staticClass:"list-view-content"},[(_vm.visibleData)?_vm._t("default",null,{"visibleData":_vm.visibleData}):_vm._e()],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }